import { render, staticRenderFns } from "./PublicationCreateProject.vue?vue&type=template&id=557e7b4b&scoped=true&"
import script from "./PublicationCreateProject.vue?vue&type=script&lang=js&"
export * from "./PublicationCreateProject.vue?vue&type=script&lang=js&"
import style0 from "./PublicationCreateProject.vue?vue&type=style&index=0&id=557e7b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e7b4b",
  null
  
)

export default component.exports